export const enum TrialExpiringModalEvent {
  CTAClicked = 'CTA clicked',
  ModalDisplayed = 'Modal displayed',
  RedirectedFromPanel = 'Redirected from panel',
}
